// @flow

export const PATH_API = 'BranchingAPI';

const isPathApi = (api?: string) => api === PATH_API;
export default isPathApi;
